import React from "react";
import css from "./index.css";
import Button from '~/components/common/Button';
// Just be used in here.
const randString = (targetLenght = 32) => {
  const stringCollection =  "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456780-";
  const stringLength = stringCollection.length;
  return Array(targetLenght).fill(1).reduce((acc)=>{
    return acc+= stringCollection.charAt(Math.floor(Math.random() * stringLength))
  },'')
}
class Uploader extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { title, fileList, uploadImg, removeImg, isMultiple} = this.props;
    const isHasImage = fileList.length > 0
    const isSingleImage = fileList.length === 1;
    return (
      <div className={css.uploaderWrap}>
        <div className={css.uploaderTitle}>{title}</div>
        <div className={css.uploaderGallery}>
          {
            ! isHasImage &&
            <label htmlFor={title} className={css.uploaderEntry}>
              <div className={css.uploaderContent}>
                <div className={css.uploaderIcon}></div>
                <div className={css.uploaderText}>Upload Files</div>
              </div>
              <input
                className={css.uploaderInput}
                type="file"
                id={title}
                accept="image/*"
                multiple={isMultiple}
                onChange={(e)=>uploadImg(e)}
              />
            </label>
          }
          {
            isSingleImage && 
            <div className={css.uploaderSingleImage} style={{backgroundImage:`url(${fileList[0] && fileList[0].url})`}}>
              <div className={css.uploaderClose} onClick={()=>removeImg(fileList[0] && fileList[0].hash)} ></div>
            </div>
          }
          {
            (isHasImage && !isSingleImage) &&
            (
              <div className={css.multipleImageWarp}>
                {
                  fileList.map(({ url, hash })=>{
                    return (
                      <div style={{backgroundImage:`url(${url})`}} className={css.image}>
                        <div className={css.uploaderClose} onClick={()=>removeImg(hash)} ></div>
                      </div>
                    )
                  })
                }
              </div>
            )
          }
        </div>
        {
          (isHasImage && !isSingleImage) &&
          (
            <label htmlFor={title+'Append'} className={css.uploaderAppend} >
              <div className={css.uploaderAppendIcon}></div>
              <div className={css.uploaderAppendText}>Add Upload Files</div>
              <input
                className={css.uploaderInput}
                type="file"
                id={title+'Append'}
                accept="image/*"
                multiple
                onChange={(e)=>uploadImg(e)}
              />
            </label>
          )
        }
      </div>
    )
  }
}



export default class Upload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      allFileList: [],
      uploadNow: false,
      disabled: true,
    }
  }
  componentDidMount() {
    const title = [
      {
        name: "Operating Authority Doc",
        multiple: false,
        type: 'dotPho',
      },
      {
        name: "W9 Form",
        multiple: true,
        type: 'w9Pho',
      },
      {
        name: "Insurance Certificates",
        multiple: true,
        type: 'insurancePho',
      }
    ]
    const list = title.map(e=> ({
      title: e.name,
      multiple: e.multiple,
      type: e.type,
      img: []
    }))
    this.setState({
      allFileList: list
    })
  }
  componentDidUpdate(prevProp, prevState) {
    const {uploadNow, allFileList} = this.state;
    const { uploadInfo } = this.props;
    const allHasFile = allFileList.reduce((acc,{img})=>{
      const hasFile = img.length > 0;
      acc = acc && hasFile;
      return acc
    }, true);
    const allUploaded = allFileList.reduce((acc,{img})=>{
      const uploaded = img.filter(({id})=> id ===null).length === 0;
      acc = acc && uploaded;
      return acc
    }, true);
    if(allHasFile && allUploaded && uploadNow) {
      this.setState({
        uploadNow: false
      })
      const imgs = allFileList.reduce((acc,cur)=> {
        acc[cur.type] = cur.img.map(img=>img.id);
        return acc
      },{})
      uploadInfo(imgs)
    }
  }
  uploadImg  = (e, index) => {
    const { uploadImg } = this.props;
    const  files = e.target.files || e.dataTransfer.files;
    return [...files].map(file => {
      const hash = randString(11); //hash key
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener("load", () => {
        const list = this.state.allFileList;
        list[index].img.push({
          id:null,
          url: reader.result,
          hash,
        })
        this.setState({
          allFileList: list,
        })
        
      }, false);
      uploadImg(file).then(res=>{
        const { allFileList } = this.state;
        const list = allFileList; 
        const fileList = list[index].img;
        const remained = fileList.filter(e=>e.hash!==hash);
        if(res.error){
          list[index].img = remained; 
          window.alert("File upload failed.");
        } else {
          const files = fileList
          const target = files.filter(e=>e.hash===hash);
          if(target.length > 0) {
            target[0].id = res.data;
            list[index].img = files;
          }
        }
        this.setState({
          allFileList: list
        })
      })
    })
  }
  removeImg = (hash,index) => {
    const { allFileList } = this.state;
    const list = allFileList;
    const fileList = list[index].img;
    const remained = fileList.filter(e=>e.hash!==hash);
    list[index].img = remained;
    this.setState({
      allFileList: list
    })
  }
  submit = () => {
    this.setState({
      uploadNow: true
    })
  } 
  render() {
    const { allFileList } = this.state;
    const allHasFile = allFileList.reduce((acc,{img})=>{
      const hasFile = img.length > 0;
      acc = acc && hasFile;
      return acc
    }, true);
    return (
      <div>
        <div className={css.uploaderHr}></div>
        <div className={css.uploaderArea}>
          {allFileList.map(({ title, img, multiple }, index) => {
            return <Uploader uploadImg = { (e)=>this.uploadImg(e, index) } removeImg = {(hash)=> this.removeImg(hash, index)}  title={ title } fileList={ img } isMultiple={multiple}></Uploader>;
          })}
        </div>
        <div className={css.uploaderBtnGroup}>
          <Button mods={['large', 'action']} onClick={this.submit} disabled={ !allHasFile }  className={css.uploaderBtn}>Submit</Button>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/UploadW9Anon/upload/index.js